export enum KsefSendSubmissionMode {
    None = 'None',
    Online = 'Online',
    Offline = 'Offline',
    Emergency = 'Emergency'
}